export class CognitoConstants {
    static readonly COGNITO_IDP = 'cognito-idp.';
    static readonly COGNTIO_AMAZON_AWS = '.amazonaws.com/';
    static readonly GET_ACCESS_TOKEN_ERROR = 'CognitoUtil: callback in getAccessToken is null...returning';
    static readonly GET_ID_TOKEN_ERROR = 'CognitoUtil: callback in getIdToken is null...returning';
    static readonly GET_REFRESH_TOKEN_ERROR = 'CognitoUtil: callback in getRefreshToken is null...returning';
    static readonly GET_REFRESH_CREDENTIALS =  'CognitoUtil: Can\'t set the credentials:' ;
    static readonly SLASH = '/';
}
